/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TreatmentQueueStatusType } from '../../models/treatment-queue-status-type';

export interface PatientTreatmentQueueIdUpdateStatusStatusPost$Params {
  id: string;
  status: TreatmentQueueStatusType;
}

export function patientTreatmentQueueIdUpdateStatusStatusPost(http: HttpClient, rootUrl: string, params: PatientTreatmentQueueIdUpdateStatusStatusPost$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patientTreatmentQueueIdUpdateStatusStatusPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as PracticeStrictHttpResponse<void>;
    })
  );
}

patientTreatmentQueueIdUpdateStatusStatusPost.PATH = '/PatientTreatmentQueue/{id}/UpdateStatus/{status}';
